import { useIntl } from 'react-intl';

import type { DeckSummary } from '../lib/decks.ts';
import { DeckList } from '../components/DeckList.tsx';
import { Alert, AlertDescription } from '../components/ui/alert.tsx';
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
} from '../components/ui/empty.tsx';

export function HomePage({
  decks,
  error,
}: {
  decks: DeckSummary[] | undefined;
  error: Error | null;
}) {
  const intl = useIntl();

  if (error)
    return (
      <>
        <Alert className="mt-4" variant="destructive">
          <AlertDescription>
            {intl.formatMessage({ id: 'web.decks.error' })}
          </AlertDescription>
        </Alert>
      </>
    );
  if (!decks)
    return (
      <>
        <p className="mt-4 text-muted-foreground">
          {intl.formatMessage({ id: 'web.decks.loading' })}
        </p>
      </>
    );
  if (decks.length === 0)
    return (
      <>
        <Empty className="mt-4 items-start justify-start p-0 text-left">
          <EmptyHeader className="items-start">
            <EmptyDescription>
              {intl.formatMessage({ id: 'web.decks.empty' })}
            </EmptyDescription>
          </EmptyHeader>
        </Empty>
      </>
    );

  return (
    <>
      <DeckList decks={decks} />
    </>
  );
}
